import { Dialog } from '@mui/material'
import dayjs from 'dayjs'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { getDataWithParams } from 'src/consumer/services/profileService'
import { useScreenSize } from 'src/customHooks/customHooks'
import { getImageLink, isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import QuoteAndReflection from '../DailyPlay/QuoteAndReflection'
import AppExclusiveScreen from '../GenericInformationModal/AppExclusiveScreen'
import { StyledInformationModalMUIPaper } from '../GenericInformationModal/GenericInformationModalStyles'
import { LoadingSpinner } from '../Loaders'
import { MentalStateTypeComponentDialog } from '../MentalStateComponent'
import PrewallAndPaywall from '../PrewallAndPaywall/PrewallAndPaywall'
import { GenericHeaderBackButton, MyPlanHeaderCircularProgress } from './MyPlanComponents'
import {
  APPlannedActivityDialogPaper,
  MPHeaderTitle,
  MPPhaseDescription,
  MPPhaseItemContainer,
  MPPhaseItemInfoText,
  MPPhaseItemTitle,
  MPPhaseItemTitleAndProgress,
  MyPlanHeader,
  MyPlanPhaseDetailSection,
  MyPlanPhasesSection,
  UAPActivityDetailsDialog,
  UAPDayContentDivider,
  UAPDayContentDividerContainer,
  UAPDayItemEventDetailsContainer,
  UAPDayItemEventDetailsSubtitle,
  UAPDayItemEventDetailsTitle,
  UAPDayItemEventsContainer,
  UAPNextPhaseHeadingContainer,
  UAPPhaseImageStyles,
  UserActivityPlanBackground,
  UserActivityPlanLayoutContainer,
  UserActivityPlanPhaseDayItemContainer,
} from './MyPlanStyles'
import { MobilePlanPhaseComponent } from './components/MobilePlanPhaseComponent/MobilePlanPhaseComponent'
import { PlannedActivityDetailsComponent } from './components/PlannedActivityDetailInfoComponent/PlannedActivityDetailsComponent'
import { PlannedActivityDayWiseListItem } from './components/PlannedActivityListing/PlannedActivityDayWiseListItem'
import { PlannedActivityStartedEndedComponent } from './components/PlannedActivityStartedEndedComponent/PlannedActivityStartedEndedComponent'
import {
  checkIfActivityIsActive,
  checkIfSelectedPhaseIsTheFirstPhase,
  checkIfSelectedPhaseIsTheLastPhase,
  createActivityPlanWithEstimatedCompletionDates,
  getPhasesWithStartedOrNotInformation,
  getRestDaysPlannedItems,
  getUniqueUserActivityProgressLogs,
  planPhaseToShowInTheList,
  showPlanPhaseInTheList,
  showThisPlanItemBasedOnIfPhaseHasStartedOrNot,
} from './user-activity-plan-helpers'

export default function UserActivityPage({ idType = 'slug', setupData, profileData, isWebview }) {
  const { planId } = useParams()
  const location = useLocation()

  // const { state } = useLocation()
  const navigate = useNavigate()
  const screenSize = useScreenSize()

  const [activityPlan, setActivityPlan] = useState()
  const [userActivity, setUserActivity] = useState()
  const [planItems, setPlanItems] = useState()
  const [phases, setPhases] = useState()
  const [loading, setLoading] = useState(true)
  const [selectedPhaseId, setSelectedPhaseId] = useState()
  const [showPlannedActivityDetails, setShowPlannedActivityDetails] = useState(false)
  const [selectedPlannedActivity, setSelectedPlannedActivity] = useState({
    item: null,
    index: null,
    signedUrls: null,
  })
  const [prewallOpen, setPrewallOpen] = useState(false)
  const [appExclusiveOpen, setAppExclusiveOpen] = useState(false)
  const [UAPLogs, setUAPLogs] = useState([])
  const planPhaseScrollRef = useRef(null)
  const isNotTablet = screenSize.width >= 980
  const selectedPhase = phases?.find((item) => item?.id === selectedPhaseId)

  const phasesAreValid = phases?.length !== 0 && !!phases

  const [mentalStateDialogOpen, setMentalStateDialogOpen] = useState(false)
  const [mentalStateDialogData, setMentalStateDialogData] = useState()

  const [quoteDialogOpen, setQuoteDialogOpen] = useState(false)
  const [quoteData, setQuoteData] = useState()

  const [todaysActivityIndex, setTodaysActivityIndex] = useState(0)
  const [selectedActivityIndex, setSelectedActivityIndex] = useState(0)

  const filteredPlannedActivities = planItems?.filter((pItem, pIndex) => {
    const day = pIndex + 1
    if (!phasesAreValid) {
      return true
    }
    if (isNotTablet) {
      return day >= selectedPhase?.firstDay && day <= selectedPhase?.lastDay
    } else {
      return true
    }
  })

  const filteredPlannedActivitiesHasAnActiveDay = useMemo(() => {
    return filteredPlannedActivities?.some((plannedActivity) => {
      return checkIfActivityIsActive(
        selectedPhase,
        plannedActivity?.index,
        userActivity,
        UAPLogs,
        plannedActivity,
      )
    })
  }, [filteredPlannedActivities, selectedPhase, userActivity, UAPLogs])

  async function getActivityPlan() {
    const resp = await getDataWithParams(`/api/secure/v3/activity-plan`, {
      field: planId,
      type: idType,
    })
    if (resp.status === 200 && isCommonResponseSuccessful(resp.data.code)) {
      const currentUserActivity = resp?.data?.data?.userActivity
      const userActivityProgressLogs = resp?.data?.data?.userActivityProgressLog || []
      const uniqueAPLogs = getUniqueUserActivityProgressLogs(userActivityProgressLogs)
      let uniqueAPLogsToUse = [...uniqueAPLogs]
      const currentActivityPlan = createActivityPlanWithEstimatedCompletionDates(
        resp?.data?.data?.activityPlan,
        uniqueAPLogsToUse,
      )
      const urlDay = location?.hash?.split('#')?.[1]
        ? parseInt(location?.hash?.split('#')?.[1])
        : null
      const phaseListToUse = getPhasesWithStartedOrNotInformation(
        currentActivityPlan?.phaseList,
        userActivityProgressLogs,
        urlDay,
      )

      setPlanItems(
        currentActivityPlan?.plannedActivities?.map((pAct, idx) => ({ ...pAct, planItemIdx: idx })),
      )

      setPhases(phaseListToUse)

      const lastStartedPhase =
        phaseListToUse?.length -
        1 -
        [...(phaseListToUse || [])]?.reverse()?.findIndex((item) => item?.started)

      console.log({ phaseListToUse, lastStartedPhase, uniqueAPLogs, currentActivityPlan })
      setSelectedPhaseId(phaseListToUse?.[lastStartedPhase || 0]?.id)
      setActivityPlan(currentActivityPlan)
      setUserActivity({ ...currentUserActivity })
      setUAPLogs(uniqueAPLogsToUse)

      const todayActivityIdx = currentActivityPlan?.plannedActivities?.findIndex((pAct, idx) => {
        return checkIfActivityIsActive(null, null, null, null, pAct)
      })

      // const urlDay = location?.hash?.split('#')?.[1] ? (location?.hash?.split('#')?.[1]) : null

      setTodaysActivityIndex(todayActivityIdx)

      setSelectedActivityIndex(
        urlDay !== null && urlDay - 1 < currentActivityPlan?.plannedActivities?.length
          ? urlDay - 1
          : todayActivityIdx,
      )
    } else {
      isWebview ? navigate(`/webview/plan/${planId}`) : navigate(`/plan/${planId}`)
    }
  }

  async function refreshActivityPlan(toggleModal) {
    console.log({ toggleModal })
    await getActivityPlan()
    toggleModal && toggleModal()
  }

  function onClickPlannedActivity(plannedActivityWithIndex) {
    setSelectedPlannedActivity(plannedActivityWithIndex)
    // setShowPlannedActivityDetails(true)
  }

  function closePlannedActivityDetails() {
    setShowPlannedActivityDetails(false)
  }

  function getNextPhaseId() {
    const nextPhaseIndex = phases?.findIndex((item) => item?.id === selectedPhaseId) + 1
    return phases?.[nextPhaseIndex]?.id
  }

  function selectNextPhase() {
    setSelectedPhaseId(getNextPhaseId())
  }

  function getNextPhase() {
    const nextPhaseIndex = phases?.findIndex((item) => item?.id === getNextPhaseId())
    return phases?.[nextPhaseIndex]
  }

  function resetToTodaysActivity() {
    console.log('resetting')
    setSelectedActivityIndex(todaysActivityIndex)
  }

  async function Setup() {
    setLoading(true)
    await getActivityPlan()
    setLoading(false)
  }

  useEffect(() => {
    Setup()
  }, [])

  useEffect(() => {
    console.log({ mentalStateDialogData })
  }, [mentalStateDialogData])

  const planCompletionProgress = useMemo(() => {
    const totalDays = activityPlan?.plannedActivities?.length
    const currentProgress = UAPLogs?.[0]?.plannedDay || 0

    console.log({ totalDays, currentProgress, UAPLogs })

    return (currentProgress / totalDays) * 100
  }, [activityPlan, UAPLogs])
  return (
    <UserActivityPlanBackground>
      {loading ? (
        <LoadingSpinner bgColor="#F5F5F599" dark />
      ) : (
        <>
          <MyPlanHeader>
            <GenericHeaderBackButton
              clickfunction={() => {
                window.history.back()
              }}
            />
            <MPHeaderTitle>{activityPlan?.title}</MPHeaderTitle>
            {/* not right, number of days should be total of days in all phases */}
            <MyPlanHeaderCircularProgress progress={planCompletionProgress} />
          </MyPlanHeader>
          <UserActivityPlanLayoutContainer onlySingleColumn={!phasesAreValid}>
            {isNotTablet && phasesAreValid && (
              <MyPlanPhasesSection>
                {phases?.map((phaseItemData, phaseIndex) => {
                  return (
                    <MPPhaseItemContainer
                      active={selectedPhaseId === phaseItemData?.id}
                      key={phaseIndex}
                      onClick={() => setSelectedPhaseId(phaseItemData?.id)}
                    >
                      <MPPhaseItemTitleAndProgress>
                        <div>
                          <MPPhaseItemTitle active={selectedPhaseId === phaseItemData?.id}>
                            {phaseItemData?.title}
                          </MPPhaseItemTitle>
                          <MPPhaseItemInfoText active={selectedPhaseId === phaseItemData?.id}>
                            <span style={{ fontWeight: '600' }}>Day {phaseItemData?.firstDay}</span>{' '}
                            to{' '}
                            <span style={{ fontWeight: '600' }}>Day {phaseItemData?.lastDay}</span>
                          </MPPhaseItemInfoText>
                        </div>
                      </MPPhaseItemTitleAndProgress>
                      <MPPhaseDescription active={selectedPhaseId === phaseItemData?.id}>
                        <div>{phaseItemData?.description}</div>
                        <UAPPhaseImageStyles
                          src={getImageLink(phaseItemData?.coverIcon)}
                          alt="phaseicon"
                        />
                      </MPPhaseDescription>
                    </MPPhaseItemContainer>
                  )
                })}
              </MyPlanPhasesSection>
            )}

            <MyPlanPhaseDetailSection ref={planPhaseScrollRef}>
              {isNotTablet ? (
                <>
                  {checkIfSelectedPhaseIsTheFirstPhase(selectedPhaseId, phases, phasesAreValid) && (
                    <PlannedActivityStartedEndedComponent userActivity={userActivity} startCard />
                  )}
                </>
              ) : (
                <PlannedActivityStartedEndedComponent userActivity={userActivity} startCard />
              )}
              {filteredPlannedActivities?.map((planItem, planItemIndex, planItemsArray) => (
                <div key={planItemIndex}>
                  {!isNotTablet && showPlanPhaseInTheList(planItem, planItemIndex, phases) && (
                    <MobilePlanPhaseComponent
                      phaseItem={planPhaseToShowInTheList(planItem, planItemIndex, phases)}
                    />
                  )}
                  {showThisPlanItemBasedOnIfPhaseHasStartedOrNot(
                    planItem,
                    planItemIndex,
                    phases,
                    UAPLogs,
                    isNotTablet,
                    phasesAreValid,
                    selectedActivityIndex,
                  ) && (
                    <>
                      {getRestDaysPlannedItems(
                        planItem,
                        planItems?.[planItem?.planItemIdx - 1],
                        userActivity,
                      )?.map((restDayPItems, rIndex) => (
                        <PlannedActivityDayWiseListItem
                          key={`${planItemIndex}-${rIndex}`}
                          planItem={{
                            ...restDayPItems,
                            noBorder:
                              rIndex === 0 &&
                              !isNotTablet &&
                              showPlanPhaseInTheList(planItem, planItemIndex, phases),
                          }}
                          planItemIndex={planItemIndex}
                          platItemsArray={rIndex + planItemIndex}
                          selectedPhase={selectedPhase}
                          userActivity={userActivity}
                          UAPLogs={UAPLogs}
                          onClickPlannedActivity={onClickPlannedActivity}
                          isNotTablet={isNotTablet}
                          active={false}
                          todaysActivityIndex={todaysActivityIndex}
                          setupData={setupData}
                        />
                      ))}

                      {/*ABOVE = REST DAYS ITEMS */}

                      <PlannedActivityDayWiseListItem
                        planItem={{
                          ...planItem,
                          noBorder:
                            !isNotTablet && showPlanPhaseInTheList(planItem, planItemIndex, phases),
                        }}
                        planItemIndex={planItemIndex}
                        platItemsArray={planItemsArray}
                        selectedPhase={selectedPhase}
                        activityPlan={activityPlan}
                        userActivity={userActivity}
                        UAPLogs={UAPLogs}
                        onClickPlannedActivity={onClickPlannedActivity}
                        planPhaseListScrollRef={planPhaseScrollRef}
                        planItemListHasActiveItem={filteredPlannedActivitiesHasAnActiveDay}
                        active={planItem?.planItemIdx === selectedActivityIndex}
                        todaysActivityIndex={todaysActivityIndex}
                        resetToTodaysActivity={resetToTodaysActivity}
                        setSelectedActivityIndex={
                          planItem?.planItemIdx !== selectedActivityIndex &&
                          setSelectedActivityIndex
                        }
                        setupData={setupData}
                        selectedPlannedActivityDetails={selectedPlannedActivity}
                        toggleActivityInfo={() => setShowPlannedActivityDetails(true)}
                        startActivityProps={{
                          togglePrewall: () => setPrewallOpen((prev) => !prev),
                          toggleAppExclusiveModal: () => setAppExclusiveOpen((prev) => !prev),
                          refreshActivityPlan: refreshActivityPlan,
                          setMentalStateDialogOpen: setMentalStateDialogOpen,
                          setMentalStateDialogData: setMentalStateDialogData,
                          setQuoteDialogOpen: setQuoteDialogOpen,
                          setQuoteData: setQuoteData,
                          setupData: setupData,
                          profileData: profileData,
                        }}
                      />
                    </>
                  )}
                </div>
              ))}
              {checkIfSelectedPhaseIsTheLastPhase(selectedPhaseId, phases) ? (
                <div></div>
              ) : (
                <>
                  {isNotTablet && (
                    <UserActivityPlanPhaseDayItemContainer
                      onClick={selectNextPhase}
                      style={{ background: '#00000033' }}
                      showPointer
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <UAPNextPhaseHeadingContainer>
                          <UAPPhaseImageStyles
                            src={getImageLink(getNextPhase()?.coverIcon)}
                            inList
                            alt="phaseicon"
                          />
                        </UAPNextPhaseHeadingContainer>
                        <UAPDayContentDividerContainer>
                          <UAPDayContentDivider invisibleBorder />
                        </UAPDayContentDividerContainer>
                        <UAPDayItemEventsContainer>
                          <UAPDayItemEventDetailsContainer>
                            <div className={`d-flex flex-column gap-2 w-100`}>
                              <UAPDayItemEventDetailsTitle>Next Phase</UAPDayItemEventDetailsTitle>
                              <UAPDayItemEventDetailsSubtitle>
                                {getNextPhase().title}
                              </UAPDayItemEventDetailsSubtitle>
                            </div>
                          </UAPDayItemEventDetailsContainer>
                        </UAPDayItemEventsContainer>
                      </div>
                    </UserActivityPlanPhaseDayItemContainer>
                  )}
                </>
              )}
              {isNotTablet ? (
                <>
                  {checkIfSelectedPhaseIsTheLastPhase(selectedPhaseId, phases) && (
                    <PlannedActivityStartedEndedComponent userActivity={userActivity} />
                  )}
                </>
              ) : (
                <PlannedActivityStartedEndedComponent userActivity={userActivity} />
              )}
            </MyPlanPhaseDetailSection>
          </UserActivityPlanLayoutContainer>
          <UAPActivityDetailsDialog
            open={showPlannedActivityDetails}
            onClose={closePlannedActivityDetails}
            PaperComponent={APPlannedActivityDialogPaper}
          >
            <PlannedActivityDetailsComponent
              activityPlan={activityPlan}
              plannedActivity={selectedPlannedActivity?.item}
              signedUrls={selectedPlannedActivity?.signedUrls}
              plannedActivityIndex={selectedPlannedActivity?.index}
              currentDayInMoment={dayjs(userActivity?.createdTime).add(
                selectedPlannedActivity?.index + selectedPhase?.firstDay - 1,
                'days',
              )}
              closePlannedActivityDetails={closePlannedActivityDetails}
              togglePrewall={() => setPrewallOpen((prev) => !prev)}
              toggleAppExclusiveModal={() => setAppExclusiveOpen((prev) => !prev)}
              refreshActivityPlan={refreshActivityPlan}
              setMentalStateDialogOpen={setMentalStateDialogOpen}
              setMentalStateDialogData={setMentalStateDialogData}
              setQuoteDialogOpen={setQuoteDialogOpen}
              setQuoteData={setQuoteData}
              setupData={setupData}
              profileData={profileData}
              totalPlannedActivities={activityPlan?.plannedActivities?.length}
            />
          </UAPActivityDetailsDialog>
        </>
      )}

      {/* prewall paywall */}
      <PrewallAndPaywall
        id="journal_play"
        secureData={setupData}
        wallIsOpen={prewallOpen}
        toggleWall={() => {
          setPrewallOpen((prev) => !prev)
        }}
      />

      {/* app exclusive screen */}
      <Dialog
        PaperComponent={StyledInformationModalMUIPaper}
        open={appExclusiveOpen}
        onClose={() => setAppExclusiveOpen(false)}
      >
        <AppExclusiveScreen closeModal={() => setAppExclusiveOpen(false)} />
      </Dialog>

      {/* mental state type dialog */}
      <MentalStateTypeComponentDialog
        open={mentalStateDialogOpen}
        onClose={() => {
          setMentalStateDialogOpen(false)
          setMentalStateDialogData()
        }}
        PaperComponent={APPlannedActivityDialogPaper}
        mentalStateDialogData={mentalStateDialogData}
        src={mentalStateDialogData?.src}
        srcId={mentalStateDialogData?.srcId}
        afterSubmitFunction={refreshActivityPlan}
      />

      {/* quote :  */}
      <QuoteAndReflection
        isQuoteModalOpen={quoteDialogOpen}
        setIsQuoteModalOpen={setQuoteDialogOpen}
        data={quoteData}
        callSource={quoteData?.src}
        callSourceId={quoteData?.srcId}
        afterSubmissionFunction={getActivityPlan}
      />
    </UserActivityPlanBackground>
  )
}

// lastCompletedDay

// subscription not coming or subscription free means no prewall checks
// otherwise checking subscription plan id and opening prewall with pricingPlanId

/* {selectedPhaseId === phaseItemData?.id ? (
                        <div>
                          <MPPhaseProgressContainer>
                            <MPPhaseProgressFilled
                              progress={getPhaseCompletionData(phaseItemData, userActivity)?.phaseProgress}
                            />
                          </MPPhaseProgressContainer>
                          <MPPhaseItemCompletedText active={selectedPhaseId === phaseItemData?.id}>
                            {`${parseInt(
                              getPhaseCompletionData(phaseItemData, userActivity)?.phaseProgress,
                            )}% completed`}
                          </MPPhaseItemCompletedText>
                        </div>
                      ) : (
                        <MPPhaseItemCompletedText active={selectedPhaseId === phaseItemData?.id}>
                          {`${parseInt(
                            getPhaseCompletionData(phaseItemData, userActivity)?.phaseProgress,
                          )}% completed`}
                        </MPPhaseItemCompletedText>
                      )} */
